import ActionTypes from '../constants/action-types';
import standardAction from '../../../utilities/standard-action';
import { RootActionTypes } from '../../../stores/types';

export default function showReturnNumberInput(): RootActionTypes {
  return standardAction(ActionTypes.SHOW_RETURN_NUMBER_INPUT);
}
